module.exports = "/_next/static/images/2c0c17eba75dd19833fa8fc3a982682b-girl_and_pig.svg.webp";